import React from "react";
import { Header, FormBoxResetPassword } from "./components";



export default function ResetPassword() {
 
  

  
  return (
    <div className="App">
      <Header mode="forgot-password" />
      <div className="container flex items-center justify-center mt-20 py-10 w-2/6">
        <FormBoxResetPassword />
      </div>
    </div>
  );
}
